const modifySelectedItem = function ({ commit }, { field, value }) {
  commit("MODIFY_SELECTED_ITEM", { field, value });
};

export default modifySelectedItem;
